import React from 'react';
import NotificationsCenter from './NotificationsCenter';
import MyConversations from '../../MyConversationsPage';

const Notifications = ({ isSociety, light }) => {
    return (
        <>
            <NotificationsCenter isSociety={isSociety} light={light} />
            <MyConversations isSociety={isSociety} light={light} />
        </>
    );
};

export default Notifications;
